import { TRANSPORTATION_FIELD_STAGE2 } from 'constants/FarmboxConstants/stage2.constants';
import { BaseItem } from 'models/Farmbox/transportation.model';
import { FieldArrayWithId } from 'react-hook-form';
import { CategoryOptions } from 'shared/components/CreateProductModal/ProductModalForm';
import styles from './farmTransportationFlow.module.scss';
import { GetFertilizerFormFields } from './stage2FarmData';
import FieldsRow from 'shared/components/FieldsRow';
import { FormType } from 'enums/FieldTypeEnums';
import React from 'react';

interface TransportationFormData {
  fertilizers?: BaseItem[];
  packagings?: BaseItem[];
}

type FormFields = FieldArrayWithId<
  TransportationFormData,
  TRANSPORTATION_FIELD_STAGE2,
  'id'
>[];
interface FormSectionProps {
  title: string;
  fields: FormFields;
  formType: TRANSPORTATION_FIELD_STAGE2;
  supplierOptions: CategoryOptions[];
  onOpenSupplierModal: (index: number, childIndex?: number) => void;
  isUnderlined?: boolean;
  isDisabled?: boolean;
}

const IndexComponent: React.FC<{ index: number }> = ({ index }) => {
  return (
    <div>
      <p className={styles.index}>{index + 1}</p>
    </div>
  );
};
const TransportationFormSection = (props: FormSectionProps) => {
  const {
    title,
    fields,
    formType,
    supplierOptions,
    onOpenSupplierModal,
    isUnderlined,
    isDisabled,
  } = props;
  const { REACT_HOOK_FORMS } = FormType;

  return (
    <div className={styles.fertilizerHeaderContainer}>
      {isUnderlined && fields?.length > 0 && (
        <div className={styles.divider}>
          <hr />
        </div>
      )}
      {fields?.length > 0 && (
        <h2 className={styles.headingContainer}>{title}</h2>
      )}
      <div className={styles.contentContainer}>
        {fields.map((field, index) => (
          <div key={field.id} className={styles.fertilizerRow}>
            <IndexComponent index={index} />
            <div className={styles.formFieldsContainer}>
              <FieldsRow
                {...GetFertilizerFormFields({
                  rowIndex: index,
                  supplierOptions,
                  openSupplierModal: () => onOpenSupplierModal(index),
                  formType,
                  isDisabled,
                })}
                formType={REACT_HOOK_FORMS}
              />
              {field.children?.map((child, childIndex) => (
                <div key={child.id} className={styles.childRow}>
                  <FieldsRow
                    {...GetFertilizerFormFields({
                      rowIndex: index,
                      childIndex,
                      supplierOptions,
                      openSupplierModal: () =>
                        onOpenSupplierModal(index, childIndex),
                      formType,
                      isDisabled,
                    })}
                    formType={REACT_HOOK_FORMS}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TransportationFormSection;
